import React, { forwardRef, useRef } from 'react'
import ReCAPTCHA from "react-google-recaptcha-enterprise";

const RecaptchaEnterprise = forwardRef((props, ref) => {

    const { sitekey, setToken } = props;
    const recaptchaInstance = useRef();

    React.useImperativeHandle(ref, () => ({
        reset: () => {
            if (recaptchaInstance.current) {
                recaptchaInstance.current.reset();
            }
        },
    }));


    function onChange(value) {
        setToken(value)
    }
    if (!sitekey) {
        return <></>
    }
    return (
        <ReCAPTCHA
            sitekey={sitekey}
            onChange={onChange}
            ref={recaptchaInstance}
        />
    )
})

export default RecaptchaEnterprise  